var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-overlay',[_c('rkm-layout-body',{attrs:{"title":"Relatório de inconsistência"},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('rkm-button',{attrs:{"color":"danger"},on:{"click":_vm.handleExit}},[_vm._v(" Sair ")])]},proxy:true}])},[_c('rkm-layout-content',[_c('Form',{ref:"Form",on:{"exit":_vm.handleExit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }